<template>
  <div class="menu_zw"></div>
  <div class="pc">
    <div class="container">
        <!-- 左侧logo -->
      <a href="/home">
        <img src="../assets/img/logo.png" alt="" />
      </a>
      <!-- 右侧导航 -->
      <el-menu class="menu_box" :default-active="activeIndex" mode="horizontal" text-color='#9DA1A9' active-text-color='#1667FF' router>
        <el-menu-item v-for="(item, index) in pageForm"
          :key="index + item.path" :index="item.path">
          <div>
            {{ item.name }}
            <div v-if="activeIndex == item.path" class="bottom_line"></div>
          </div>
          
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, ref, watch } from "vue";
import { useRoute } from 'vue-router'
export default {
  setup() {
    const state = computed(() => useStore().state.client);
    const activeIndex = ref('home')
    const route = useRoute()
    watch(()=>route.path,()=>{
      activeIndex.value!==route.path.substring(1)?activeIndex.value=route.path.substring(1):null
    })
    const pageForm = ref([
      {
        name: "首页",
        path: "home",
      },
      {
        name: "新型储能",
        path: "energyStorage",
      },
      {
        name: "绿能专家",
        path: "greenEnergyExpert",
      },
      {
        name: "绿能派",
        path: "greenEnergy",
      },
      {
        name: "关于我们",
        path: "about",
      }
    ])
    return {
      state,
      pageForm,
      activeIndex
    };
  },
};
</script>

<style lang='scss'>
.menu_zw{
  width: 100%;
  height: 100px;
}
.pc {
  width: 100%;
  height: 100px;
  position: fixed;
  background: #fff;
  z-index: 9999;
  border-bottom: 1px solid #DEE3EC;
  top: 0;
  left: 0;
  .container {
    height: 100px;
    margin: 0 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    a{
      img {
        height: 50px;
      }
    }
    .el-menu{
        border: none;
        .el-menu-item {
          font-size: 22px;
          color: #768195;
          padding: 0 60px;
          font-weight: 200;
        }
        .el-menu-item:hover {
          color: #1667FF !important;
        }
        .is-active{
          border-bottom: 0;
          border-bottom-color: #fff !important;
          color: #1667FF !important;
        }
      }
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-width: 4px;
  }
  .menu_box {
    .is-active {
      position: relative;
      @keyframes lineRun {
        0% {
          width: 0;
        }
        25% {
          width: 25%;
        }
        50% {
          width: 50%;
        }
        75% {
          width: 75%;
        }
        100% {
          width: 100%;
        }
      }
      >div{
        position: relative;
      }
      .bottom_line {
        position: absolute;
        left: 50%;
        bottom: -22px;
        width: 100%;
        height: 4px;
        transform: translate(-50%, -50%);
        // border-radius: 30px;
        background: #1667FF;
        transition: width 0.5s ease-out;;
        animation: lineRun;
        animation-duration: .3s;
        animation-timing-function: ease-in-out;
        animation-fill-mode: forwards;
      }
    }
  }
}
.mobile{
  width: 100%;
  height: 100px;
  position: fixed;
  background: #fff;
  z-index: 9999;
  border-bottom: 1px solid #DEE3EC;
  top: 0;
  left: 0;
  .container{
    font-size: 0;
    box-sizing: border-box;
    padding: .2rem .1rem;
    a{
      img{
        width: 2.5rem;
      }
    }
  }
}
</style>